import axios from 'axios'
import qs from 'qs'
// import router from '../router'
// import store from '../store/index'
import { Notification, Loading } from 'element-ui'
import {BASE_URL} from './config'
// 创建 axios 实例
let http = axios.create({
  // headers: {'Content-Type': 'application/json'},
  baseURL:BASE_URL,
  timeout: 60000
})

// 请求加载拦截
let loadingRequestCount = 0
let loading

function showLoading() {
  if (loadingRequestCount === 0) {
    loading = Loading.service({
      lock: true,
      text: '加载中……',
    })
  }
  loadingRequestCount += 1
}

function hideLoading() {
  if (loadingRequestCount <= 0) {
    return
  }
  loadingRequestCount -= 1

  if (loadingRequestCount === 0) {
    loading.close()
  }
}

// 设置 post、put 默认 Content-Type
http.defaults.headers.post['Content-Type'] = 'application/json'

// 添加请求拦截器
http.interceptors.request.use(config => {
  if (config.other.isLoading) {
    showLoading()
  }

  if (localStorage.getItem('loginToken')) {
    config.headers.Authorization = localStorage.getItem('loginToken');
  }
  if (config.method === 'post' || config.method === 'put') {
    // post、put 提交时，将对象转换为string, 为处理Java后台解析问题
    // config.data = JSON.stringify(config.data)  //若是content-type为application/json，则去掉该注释
    //当content-type为application/x-www-form-urlencoded，则去掉该注释,进行序列化
    //当content-type为multipart/form-data，data无需任何处理，已经是formData

    if(config.headers.post['Content-Type']=="application/x-www-form-urlencoded"){
      let data=config.data;
      config.data = qs.stringify(data);//对参数进行序列化
    }else if(config.headers.post['Content-Type']=="application/json"){
      config.data = JSON.stringify(config.data)
    }
  } else if (config.method === 'get') {
    // 给GET 请求后追加时间戳， 解决IE GET 请求缓存问题
    let symbol = config.url.indexOf('?') >= 0 ? '&' : '?'
    config.url += symbol + '_=' + Date.now()
  }
  // 请求发送前进行处理
  return config
}, error => {
  Notification.error({
    title: '错误',
    message: '请求失败',
    duration:1500
  });
  // 请求错误处理
  return Promise.reject(error)
})

// 添加响应拦截器
http.interceptors.response.use(response => {
  if (response.config.other.isLoading) {
    hideLoading()
  }

  const { data } = response

  if(data.status === 'success'){
    return data
  } else {
    //统一处理错误返回提示
    Notification.error({
      title: '错误',
      message: data.message,
      duration: 1500,
    })
    // if(data.code == 20001){
    //   // 登录超时
    //   store.commit('removeLoginToken')
    //   if (router.currentRoute.fullPath != '/login') {
    //     router.push({
    //       path: '/login',
    //       query: {
    //         redirect: router.currentRoute.fullPath,
    //       },
    //     })
    //   }
    // }
    return Promise.reject(new Error(data.message))
  }
}, error => {
  hideLoading()

  // let info = {}

  // let {status, statusText, data} = error.response

  // if (!error.response) {
  //   info = {
  //     code: 5000,
  //     msg: 'Network Error'
  //   }

  // } else {
  //   // 此处整理错误信息格式
  //   info = {
  //     code: status,
  //     data: data,
  //     msg: statusText
  //   }
  // }

  //统一处理错误返回提示
  Notification.error({
    title: '错误',
    message: '请求失败',
    duration:1500
  })

  return Promise.reject(error)
})

/**
 * 创建统一封装过的 axios 实例
 * @return {AxiosInstance}
 */
export default function () {
  return http
}
